interface LogoMarkProps {
  size?: number
  className?: string
}

// The Freehold mark: a layered "vault" glyph on the brand chip. Sized in px so
// it works from a 24px sidebar mark to a 48px splash.
export function LogoMark({ size = 28, className = '' }: LogoMarkProps) {
  const inner = Math.round(size * 0.58)
  return (
    <div
      className={`flex shrink-0 items-center justify-center bg-primary text-primary-foreground ${className}`}
      style={{ width: size, height: size, borderRadius: Math.max(6, Math.round(size * 0.27)) }}
    >
      <svg width={inner} height={inner} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l8 4.5-8 4.5-8-4.5L12 3z" fill="currentColor" />
        <path d="M4 12l8 4.5 8-4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
        <path d="M4 16.5l8 4.5 8-4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.3" />
      </svg>
    </div>
  )
}
